module.exports = __webpack_public_path__ + "img/santander.89b8128.png";